import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useT, useRoute } from "@/i18n";
import { CONSENT_KEY, loadTrackingScripts } from "@/lib/tracking";

export default function CookieConsent() {
  const t = useT();
  const route = useRoute();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(CONSENT_KEY);
    if (stored === "accepted") loadTrackingScripts();
    else if (!stored) setVisible(true);
  }, []);

  const decide = (choice) => {
    localStorage.setItem(CONSENT_KEY, choice);
    setVisible(false);
    if (choice === "accepted") loadTrackingScripts();
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-consent-banner"
      className="fixed bottom-0 inset-x-0 z-[100] bg-black text-white border-t border-white/10"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 lg:px-14 py-6 flex flex-col md:flex-row md:items-center gap-5">
        <div className="flex-1">
          <p className="text-xs uppercase tracking-[0.3em] text-[#C20E1A] font-bold mb-2">
            {t.cookie.title}
          </p>
          <p className="text-sm text-white/70 leading-relaxed max-w-3xl">
            {t.cookie.text}{" "}
            <Link
              to={route("privacy")}
              data-testid="cookie-privacy-link"
              className="underline hover:text-white transition-colors"
            >
              {t.cookie.privacy}
            </Link>
          </p>
        </div>
        <div className="flex items-center gap-3 shrink-0">
          <button
            data-testid="cookie-decline-btn"
            onClick={() => decide("declined")}
            className="border border-white/30 text-white px-6 py-3 text-[10px] uppercase tracking-[0.25em] font-bold hover:bg-white hover:text-black transition-colors duration-300"
          >
            {t.cookie.decline}
          </button>
          <button
            data-testid="cookie-accept-btn"
            onClick={() => decide("accepted")}
            className="bg-[#C20E1A] text-white px-6 py-3 text-[10px] uppercase tracking-[0.25em] font-bold hover:bg-white hover:text-black transition-colors duration-300"
          >
            {t.cookie.accept}
          </button>
        </div>
      </div>
    </div>
  );
}
